import Image from '../../images/areyoulost.png'

const AreYouLost = () => {
  return (
    <section className="areyoulost">
        <div className="container areyoulost__container">
            <div className="areyoulost-left">
                <div className="areyoulost-circle"></div>
                <div className="areyoulost-image">
                    <img src={Image} alt="Space-cat Will Take You Home" />
                </div>
            </div>
            <div className="areyoulost-right">
                <p className="p1">How'd you end up here?</p>
                <p className="p2">...gimme a second,</p>
                <p className="p3">I'll take you back home.</p>
            </div>
        </div>
    </section>

  )
}

export default AreYouLost